<template>
  <div>
    <div id="table-container">
      <ts-table :records="resources" :columnLengths="18">
        <template v-slot:thead>
          <thead>
            <tr>
              <th rowspan="2">{{ $t('campusAttendance.branch') }}</th>
              <th rowspan="2" class="text-center">
                {{ $t('campusAttendance.cardNumber') }}
              </th>
              <th rowspan="2">{{ $t('campusAttendance.studentName') }}</th>
              <th rowspan="2" class="text-center">
                {{ $t('campusAttendance.sex') }}
              </th>
              <th rowspan="2" class="text-center">
                {{ $t('campusAttendance.datescan') }}
              </th>
              <th colspan="2" class="text-center">
                {{ $t('campusAttendance.t1') }}
              </th>
              <th rowspan="2" class="text-center">
                {{ $t('campusAttendance.total1') }}
              </th>
              <th colspan="2" class="text-center">
                {{ $t('campusAttendance.t2') }}
              </th>
              <th rowspan="2" class="text-center">
                {{ $t('campusAttendance.total2') }}
              </th>
              <th colspan="2" class="text-center">
                {{ $t('campusAttendance.t3') }}
              </th>
              <th rowspan="2" class="text-center">
                {{ $t('campusAttendance.total3') }}
              </th>
              <th colspan="2" class="text-center">
                {{ $t('campusAttendance.t4') }}
              </th>
              <th rowspan="2" class="text-center">
                {{ $t('campusAttendance.total4') }}
              </th>
              <th rowspan="2">{{ $t('actions') }}</th>
            </tr>
            <tr>
              <th>{{ $t('campusAttendance.checkin') }}</th>
              <th>{{ $t('campusAttendance.checkout') }}</th>
              <th>{{ $t('campusAttendance.checkin') }}</th>
              <th>{{ $t('campusAttendance.checkout') }}</th>
              <th>{{ $t('campusAttendance.checkin') }}</th>
              <th>{{ $t('campusAttendance.checkout') }}</th>
              <th>{{ $t('campusAttendance.checkin') }}</th>
              <th>{{ $t('campusAttendance.checkout') }}</th>
            </tr>
            <TableProgressBar v-show="loading" :columnLength="18" />
          </thead>
        </template>
        <template v-slot="{ record }">
          <td class="ts-whitespace-no-wrap">
            {{ record.branch ? record.branch.branch_name_en : '' }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.card_number }}
          </td>
          <td class="ts-whitespace-no-wrap">
            {{ record.student ? record.student.full_name_en : '' }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.student ? record.student.gender : '' }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.datescan }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">{{ record.t1 }}</td>
          <td class="ts-whitespace-no-wrap text-center">{{ record.t2 }}</td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.total_hour1 }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">{{ record.t3 }}</td>
          <td class="ts-whitespace-no-wrap text-center">{{ record.t4 }}</td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.total_hour2 }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">{{ record.t5 }}</td>
          <td class="ts-whitespace-no-wrap text-center">{{ record.t6 }}</td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.total_hour3 }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">{{ record.t7 }}</td>
          <td class="ts-whitespace-no-wrap text-center">{{ record.t8 }}</td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.total_hour4 }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            <a
              v-if="record.scan_status == 'Manual' || record.t2 == null"
              href="#"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
              v-tooltip="$t('edit')"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EditComponent from '../edit.vue'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'

export default {
  name: 'detail',
  components: { TableProgressBar },
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  created () {},
  computed: {
    ...mapState('campusAttendanceTeacher', ['resources', 'pagination'])
  },
  methods: {
    edit (data) {
      this.$modal.show(
        EditComponent,
        {
          editData: data
        },
        {
          height: 'auto',
          width: '580px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.$emit('fetch')
        }
      )
    }
  }
}
</script>
<style scoped>
.no-padding-top {
  padding: 0 1rem 1rem 1rem;
}
#table-container {
  min-height: 60vh;
  overflow-y: scroll;
}

table > tbody > tr td {
  vertical-align: middle;
}

.table > thead > tr > th {
  border: 1px solid #b6c2c9;
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
